import Vue from 'vue'
import App from './App.vue'

import { router } from './route'

import VueTheMask from 'vue-the-mask'
import VueFire from 'vuefire'
import VuejsDialog from 'vuejs-dialog'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import money from 'v-money'

Vue.use(money, {precision: 4})
const fb = require('./config/db.js');

let app = '';

Vue.use(VueTheMask)
Vue.use(VueFire)
Vue.use(VuejsDialog)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false



Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(new Date(value.seconds * 1000).toString()).format('DD/MM/YYYY');
  }
});

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(new Date(value.seconds * 1000).toString()).format('DD/MM/YYYY HH:mm');
  }
});

Vue.filter('formatDateDb', function(value) {
  if (value) {
    return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }
});

router.beforeEach((to, from, next) => {
  const currentUser = fb.auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) next('login');
  else if (!requiresAuth && currentUser) next('home');
  else next();
});

fb.auth.onAuthStateChanged(() => {
  if(!app){
    app = new Vue({
      render: h => h(App),
      router
    }).$mount('#app')    
  }
});
